import axios from "axios";

export default class Service {
    constructor() {
        this.url = "/api/Groups/";
    }

    getUserGroups() {
        return axios.get(this.url + "GetUserGroups");
    }

    getGroupWithUsers(guid) {
        return axios.get(this.url + "GetGroupWithUsers", { params: { guid } });
    }

    upsertGroup(group) {
        return axios.post(this.url + "UpsertGroup", group);
    }

    getUserInvitations() {
        return axios.get(this.url + "GetUserInvitations");
    }

    getSentInvitations() {
        return axios.get(this.url + "GetSentInvitations");
    }

    createInvitation(request) {
        return axios.post(this.url + "CreateInvitation", request);
    }

    respondToInvitation(request) {
        return axios.post(this.url + "RespondToInvitation", request);
    }
}